import { ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { routes } from './routes'
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withInterceptorsFromDi, withInterceptors, provideHttpClient, withFetch } from '@angular/common/http';
import { apiInterceptor } from './app/modules/core/interceptors/api.interceptor';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from './app/modules/shared/services/notification.service';
import { LoggingService } from './app/modules/shared/services/logging.service';
import { ErrorHandlerService } from './app/modules/core/services/error.handler.service';
import { ConfigModule, MsalApplicationModule } from './config';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModuleForRoot } from './app/modules/core/utilities/places-translation-module';

// Do not bootstrap the Angular app when loaded inside an MSAL silent-auth iframe.
// MSAL v5 uses an iframe bridge (postMessage) to read the token response — Angular
// does not need to run inside the iframe, and bootstrapping it causes block_iframe_reload.
// Note: !window.opener must NOT be here — tabs opened via window.open() have opener set,
// and excluding them would break the OMS.RA.Web → OMS.Map deep-link flow.
if (window === window.parent) {
    bootstrapApplication(AppComponent, {
        providers: [
            provideZoneChangeDetection(),provideRouter(routes, withComponentInputBinding()),
            importProvidersFrom([MsalApplicationModule.forRoot(), MatDialogModule, TranslateModuleForRoot, MatSnackBarModule]),
            ConfigModule.init(),
            // deps på ConfigService fungerar inte för ErrorHandler? Se: https://stackoverflow.com/a/45200115/1022179.
            { provide: ErrorHandler, useClass: ErrorHandlerService, deps: [LoggingService, NotificationService, TranslateService] },
            provideHttpClient(withFetch(), withInterceptorsFromDi(), withInterceptors([apiInterceptor])),
            provideAnimations(),
            { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
            { provide: MAT_DATE_LOCALE, useValue: 'sv' },
            { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
        ]
    })
      .catch(err => console.error(err));
}
